import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BugsnagService } from '../../services/Bugsnag.service';
import { OptanonService } from '../../services/optanon.service';
import { ABTestSlice } from '../../store/ABTest/ABTest.slice';
var isPerformanceCategoryGranted = OptanonService.isPerformanceGranted();
var ErrorBoundary = BugsnagService.getErrorBoundaryDummyComponent();
if (!isPerformanceCategoryGranted) {
    BugsnagService.skipFlow();
}
if (isPerformanceCategoryGranted &&
    typeof window !== 'undefined' &&
    !!window.ENV) {
    var _a = window.ENV, bugsnagApiKey = _a.bugsnagApiKey, releaseVersion = _a.releaseVersion, environment = _a.environment;
    BugsnagService.init(bugsnagApiKey, releaseVersion, environment);
    ErrorBoundary = BugsnagService.getErrorBoundaryComponent();
}
export var LogsMonitoringObserver = function (_a) {
    var children = _a.children;
    var activeFeatures = useSelector(ABTestSlice.selectors.getAllFeatures);
    useEffect(function () {
        Object.entries(activeFeatures).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var variant = typeof value !== 'undefined' ? String(value) : value;
            BugsnagService.addFeatureFlag(key, variant);
        });
    }, [activeFeatures]);
    return React.createElement(ErrorBoundary, null, children);
};
